import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import { Table, Text } from '@domain-group/suit-theme'

import PublicationProductActions from '../PublicationProductActions'

const buildColumns = () => [
  {
    title: 'Title',
    dataKey: 'title',
    cellProps: {
      position: 'sticky',
      left: 0,
    },
  },
  {
    title: 'Product Code',
    dataKey: 'product_code',
  },
  {
    title: 'Rows',
    dataKey: 'rows',
    cellProps: {
      width: 40,
    },
  },
  {
    title: 'Columns',
    dataKey: 'columns',
    cellProps: {
      width: 40,
    },
  },
  {
    title: 'Width (mm)',
    dataKey: 'width',
    cellProps: {
      width: 40,
    },
  },
  {
    title: 'Height (mm)',
    dataKey: 'height',
    cellProps: {
      width: 40,
    },
  },
  {
    title: 'Bleed (mm)',
    dataKey: 'bleed',
    cellProps: {
      width: 40,
    },
  },
  {
    title: 'Actions',
    dataKey: 'id',
    cellProps: {
      width: 80,
      textAlign: 'center',
    },
    render: id => <PublicationProductActions publicationProduct={{ id }} />,
  },
]

const PublicationProductsTable = (props) => {
  const { publicationProducts } = props

  const memoColumns = useMemo(() => buildColumns(), [publicationProducts.length])

  return (
    <Table
      boxProps={{ border: 'none', maxHeight: 300, overflowY: 'auto' }}
      columns={memoColumns}
      data={publicationProducts}
      stickyHeader
    />

  )
}

PublicationProductsTable.propTypes = {
  publicationProducts: PropTypes.array.isRequired,
}

export default React.memo(PublicationProductsTable)
